import { Chip, Stack, Tab, Tabs } from '@mui/material';

export type TabItem<T extends string> = { value: T; label?: string; count?: number };

/** A tab is its name, or an object when it needs a different label or a count */
type Props<T extends string> = { tabs: readonly (T | TabItem<T>)[]; value: T; onChange: (value: T) => void };

/** A row of tabs that scrolls sideways on a narrow screen. A tab can carry a count badge. */
export function TabStrip<T extends string>({ tabs, value, onChange }: Props<T>) {
  return (
    <Tabs value={value} onChange={(_e, v: T) => onChange(v)} variant="scrollable" scrollButtons={false}>
      {tabs.map((item) => {
        const t: TabItem<T> = typeof item === 'string' ? { value: item } : item;
        return (
          <Tab
            key={t.value}
            value={t.value}
            sx={t.count === undefined ? undefined : { minWidth: 0, px: 1 }}
            label={
              t.count === undefined ? (
                (t.label ?? t.value)
              ) : (
                <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
                  <span>{t.label ?? t.value}</span>
                  <Chip size="small" color={t.value === value ? 'primary' : 'default'} label={t.count} />
                </Stack>
              )
            }
          />
        );
      })}
    </Tabs>
  );
}
